import { ActionContext } from 'vuex';
import { LoanData, LoanDetailsData } from '@/interfaces/loan';
import { getLoanInfo, getAutopay } from '@/api/loan';

type Context = ActionContext<LoanData, never>;

export async function fetchLoanData(
  context: Context,
  loanNumber?: string
): Promise<LoanDetailsData> {
  const { data } = await getLoanInfo(loanNumber);

  context.commit('setLoanData', data);

  return data;
}

export async function getAutopayInfo(
  context: Context,
): Promise<void> {
  try {
    const { data } = await getAutopay();
    context.commit('setAutopayDetails', data);
  } catch {
    context.commit('setAutopayDetails', false);
  }
}
